import { CtDraft, CtOrder } from '@/models/interfaces/content-type'
import { UUID } from '@Protium/vue-ozone-utils'

export enum IssueTrackerView {
  Drafts = 'drafts',
  Issues = 'issues'
}

export interface IssueTrackerState {
  view?: { id: string, label: string },
  active?: UUID,
  activeItem?: CtDraft | CtOrder | null
}
